interface Joke {
    Comedian: string;
    Setup: string;
    Punchline: string;
}

const jokes: Joke[] = [
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "My belt holds up my pants and my pants have belt loops that hold up the belt.",
        "Punchline": "What the fuck's really going on down there? Who is the real hero?"
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I like escalators, because an escalator can never break; it can only become stairs.",
        "Punchline": "There would never be an \"Escalator Temporarily Out of Order\" sign. Only an \"Escalator Temporarily Stairs... Sorry for the Convenience.\""
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "My friend asked me if I wanted a frozen banana",
        "Punchline": "I said \"No... but I want a regular banana later, so yeah.\""
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I had a paper route when I was a kid. I was a paperboy. I was supposed to go to 2,000 houses..",
        "Punchline": "or two dumpsters."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I don't have a girlfriend.",
        "Punchline": "I just know a girl who would get really mad if she heard me say that."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "One time a guy handed me a picture, he said \"Here's a picture of me when I was younger.\"",
        "Punchline": "Every picture of you is when you were younger."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "My sister had a baby to try to \"save the relationship.\"",
        "Punchline": "But I still don't talk to her."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "Whenever I meet a pretty girl, the first thing I look for is intelligence.",
        "Punchline": "Because if she doesn't have that, then she's mine."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "Whenever I think of the past",
        "Punchline": "It brings back so many memories."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "If at first you don't succeed",
        "Punchline": "Then skydiving definitely isn't for you."
    },
    {
        "Comedian": "Demetri Martin",
        "Setup": "I keep a lighter in my back pocket at all times.",
        "Punchline": "I'm not a smoker, I just really like certain songs."
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "My wife and I were happy for 20 years",
        "Punchline": "Then we met."
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "I found there was only one way to look thin",
        "Punchline": "Hang out with fat people."
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "My Uncle's dying wish - he wanted me on his lap.",
        "Punchline": "He was in the electric chair."
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "The way my luck is running",
        "Punchline": "If I was a politician, I'd be honest."
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "I saved a girl from being attacked last night.",
        "Punchline": "I controlled myself."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "I used to work at a fire hydrant factory.",
        "Punchline": "You couldn't park anywhere near the place."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "My doctor told me I shouldn't work out til I'm in better shape.",
        "Punchline": "I told him 'alright, don't send me a bill til I pay you\""
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "If I ever had twins",
        "Punchline": "I'd use one for parts."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "I wrote a few children's books.",
        "Punchline": "Not on purpose."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "I was sad because I had no shoes, til I met a met who had no feet.",
        "Punchline": "So I said \"got any shoes you're not using?\""
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "I stayed up all night playing poker with tarot cards.",
        "Punchline": "I got a full house and four people died."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "When I was crossing the border into Canada, they asked if I had any firearms with me.",
        "Punchline": "I said \"well, what do you need?\""
    },
    {
        "Comedian": "Demetri Martin",
        "Setup": "I went into a clothing store, and the lady asked me what size I was.",
        "Punchline": "I said 'Actual. I'm not to scale.'"
    },
    {
        "Comedian": "Demetri Martin",
        "Setup": "If I ever saw an amputee getting hanged",
        "Punchline": "I'd probably just start calling out letters."
    },
    {
        "Comedian": "Demetri Martin",
        "Setup": "A know-it-all is a person who knows everything",
        "Punchline": "except for how annoying he is."
    },
    {
        "Comedian": "Demetri Martin",
        "Setup": "I need to develop some patience",
        "Punchline": "...immediately"
    },
    {
        "Comedian": "Demetri Martin",
        "Setup": "I used to play sports.",
        "Punchline": "Then I realized you can buy trophies."
    },
    {
        "Comedian": "Emo Phillips",
        "Setup": "A computer once beat me at chess.",
        "Punchline": "But it was no match for me at kickboxing."
    },
    {
        "Comedian": "Emo Phillips",
        "Setup": "I once had a large gay following",
        "Punchline": "But I ducked into an alleyway and lost him."
    },
    {
        "Comedian": "Emo Phillips",
        "Setup": "I was in a bar the other night, hopping from barstool to barstool, trying to get lucky.",
        "Punchline": "But there wasn't any gum under any of them."
    },
    {
        "Comedian": "Emo Phillips",
        "Setup": "I discovered my wife in bed with another man, and I was crushed.",
        "Punchline": "So I said 'get off me, you two!'"
    },
    {
        "Comedian": "Emo Phillips",
        "Setup": "I'm a great lover",
        "Punchline": "I'll bet"
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "I don't know if you've ever helped someone get an abortion. It's a big favor. I'm as pro-choice as they come. But still, as I'm driving her, I'm thinking....",
        "Punchline": "\"Goddamn, there has got to be a better way to come up with new material.\""
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "My girlfriend is upset about her new haircut. I don't understand why she's crying.",
        "Punchline": "I'm the one who has to get a new girlfriend."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "My girlfriend asked me if I only love her for her body.",
        "Punchline": "I said \"no, baby. Just parts of it.\""
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "I had a friend set me up on a blind date. It was a disaster. She was a burn victim.",
        "Punchline": "...by the end of the night."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "I'm actually a really nice guy",
        "Punchline": "..once you get to blow me."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "The best way to break up with a girl is like",
        "Punchline": "Taking off a bandaid....slowly and in the shower."
    },
    {
        "Comedian": "Demetri Martin",
        "Setup": "I like to use 'I Can't Believe it's Not Butter' on my toast in the morning",
        "Punchline": "because sometimes when I eat breakfast, I like to be incredulous."
    },


   
    {
        "Comedian": "Demetri Martin",
        "Setup": "The worst time to have a heart attack is during a game of charades",
        "Punchline": "...or during a game of fake heart attack."
    },
    
    {
        "Comedian": "Demetri Martin",
        "Setup": "If I have to move up in a building, I choose the elevator over the escalator",
        "Punchline": "Because one time I was riding the escalator and I tripped... I fell down the stairs for an hour and a half."
    },
    {
        "Comedian": "Demetri Martin",
        "Setup": "I think that when you get dressed in the morning, sometimes you're really making a decision about your behavior for the day",
        "Punchline": "Like if you put on flipflops, you're saying 'hope I don't get chased today.'"
    },
    {
        "Comedian": "Demetri Martin",
        "Setup": "I like to play chess with old men in the park",
        "Punchline": "although it's hard to find 32 of them."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "I would never hit a woman.",
        "Punchline": "Even if she had a knife or a stutter."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "My mom's been having a hard time lately. She just found out that she has to have both breasts removed...",
        "Punchline": "if she's ever going to be good at golf."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "Sure, my uncle killed himself playing Russian Roulette.",
        "Punchline": "But I choose to remember him as a great Russian Roulette player."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "I prefer to sleep with deaf girls.",
        "Punchline": "Those crazy chicks never have a safe word."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "It's always difficult when someone close to you passes away.",
        "Punchline": "But it's really tough when they're on top of you."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "I got an email from my ex, telling me she has aids. I didn't know how to comfort her..",
        "Punchline": "so I just wrote back \"I know.\""
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "Father's day makes me wish that I could talk to my Dad just one more time...",
        "Punchline": "..instead of all the time."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "I feel worthless. My girlfriend was attacked on the subway yesterday.",
        "Punchline": "and I can't even enjoy it."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "When I was little, I would burn ants with a magnifying glass.",
        "Punchline": "But now that I'm older, I'm more of a cat guy."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "Wearing a turtleneck is like",
        "Punchline": "being strangled by a really weak guy... all day."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I saw on HBO they were advertising this boxing match, it said \"It's a fight to the finish\"...",
        "Punchline": ".. that's a good place to end."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "This jacket is dry clean only...",
        "Punchline": "which means it's dirty."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I'm against picketing",
        "Punchline": "but I don't know how to show it."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I like to play blackjack. I'm not addicted to gambling...",
        "Punchline": "I'm addicted to sitting in a semicircle"
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "My hotel doesn't have a 13th floor because of superstition.",
        "Punchline": "But, c'mon man, people on the 14th floor, you know what floor you're really on."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I got a jump rope. That thing's just a rope, man.",
        "Punchline": "You gotta make the jump happen."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "You know there's a fishing show on TV? They catch the fish, but they let it go.",
        "Punchline": "They don't want to eat the fish, but they do want to make it late for something."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I like the Fed Ex driver",
        "Punchline": "because he's a drug dealer and he don't even know it."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I put fruit on top of my waffles...",
        "Punchline": "because I want something to brush off."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "In Venice, Italy, they don't have streets, they have canals.",
        "Punchline": "So in Venice, Italy, we have to keep the kids off the canals"
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "That would suck if a drink was ice cold...",
        "Punchline": "because then it would be impossible to drink."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I played in a death metal band. People either loved us or they hated us...",
        "Punchline": "or they thought we were OK."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I was at a casino, I was standing by the door, and the security guard came over and he said \"You're gonna have to move. You're blocking the fire exit,\" as if though there was a fire, I wasn't gonna run.",
        "Punchline": "If you're flammable and have legs, you are never blocking a fire exit"
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I know a lot about cars, man.",
        "Punchline": "I can look at a car's headlights and tell you exactly which way it's going."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "That would be cool if you lived with a monster...",
        "Punchline": "you would never get hiccups!"
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I gotta idea for sweat shops..",
        "Punchline": "air conditioning! Problem solved."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I had a piece of Carefree sugarless gum...",
        "Punchline": "and I was still worried."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I wanted to buy a candle holder, but the store didn't have one.",
        "Punchline": "So I got a cake."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "If I had nine of my fingers missing...",
        "Punchline": "I wouldn't type any slower."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I'm a heroine addict..",
        "Punchline": "I need to have sex with women who saved someone's life."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "You can't have everything",
        "Punchline": "where would you put it?"
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "When I was little, my grandfather used to make me stand in a closet for five minutes without moving",
        "Punchline": "He said it was elevator practice."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "I used to work at a fire hydrant factory.",
        "Punchline": "You couldn't park anywhere near the place."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "My doctor told me I shouldn't work out til I'm in better shape.",
        "Punchline": "I told him 'alright, don't send me a bill til I pay you\""
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "If I ever had twins",
        "Punchline": "I'd use one for parts."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "I wrote a few children's books.",
        "Punchline": "Not on purpose."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "I was sad because I had no shoes, til I met a met who had no feet.",
        "Punchline": "So I said \"got any shoes you're not using?\""
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "I stayed up all night playing poker with tarot cards.",
        "Punchline": "I got a full house and four people died."
    },
    {
        "Comedian": "Steven Wright",
        "Setup": "When I was crossing the border into Canada, they asked if I had any firearms with me.",
        "Punchline": "I said \"well, what do you need?\""
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "I told my wife the truth. I told her I was seeing a psychiatrist.",
        "Punchline": "Then she told me the truth: that she was seeing a psychiatrist, two plumbers, and a bartender."
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "I could tell that my parents hated me.",
        "Punchline": "My bath toys were a toaster and a radio."
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "My wife met me at the door the other night in a sexy negligee.",
        "Punchline": "Unfortunately, she was just coming home."
    },
    
    
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "I remember the time I was kidnapped and they sent a piece of my finger to my father.",
        "Punchline": "He said he wanted more proof."
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "My wife's cooking is so bad",
        "Punchline": "the flies in our neighborhood pitched in to fix the holes in our screens."
    },
    {
        "Comedian": "Rodney Dangerfield",
        "Setup": "Last week my house was on fire.",
        "Punchline": "My wife told the kids, 'Be quiet, you'll wake up Daddy.'"
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "You know, I'm sick of following my dreams, man.",
        "Punchline": "I'm just gonna ask where they're going and hook up with 'em later."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I wrote a script and I gave it to a guy who reads scripts. And he read it and he said he really likes it, but he thinks I need to re-write it.",
        "Punchline": "I said \"Fuck that, I'll just make a copy.\""
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I got some tartar control toothpaste.",
        "Punchline": "I still got tartar, but that shit's under control."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I bought myself a parrot, the parrot talked.",
        "Punchline": "But it did not say \"I'm hungry\"... so it died."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I was gonna have my teeth whitened",
        "Punchline": "But then I said, \"Fuck that, I'll just get a tan instead.\""
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I can read minds.",
        "Punchline": "But it's pointless because I'm illiterate."
    },
    {
        "Comedian": "Mitch Hedberg",
        "Setup": "I haven't slept for 10 days...",
        "Punchline": "because that would be too long."
    },
    {
        "Comedian": "Anthony Jeselnik",
        "Setup": "My girlfriend wants an open relationship. I said no way.",
        "Punchline": "What kind of man would I be if I had to tell my friends I date you?"
    }
];

export const getRandomJoke = (): Joke => {
    return jokes[Math.floor(Math.random() * jokes.length)];
};

export default jokes;
